import React from "react";
import { HardwareContext } from "./hardware-context";
import { usePageHardwareHook } from "./hardware-hooks";

export function PageContextHardwareProvider({
  children,
}: {
  children: React.ReactNode;
}) {
  const value = usePageHardwareHook();

  return (
    <HardwareContext.Provider value={value}>
      {children}
    </HardwareContext.Provider>
  );
}
